import { initAbDetailSampleTracking } from '@/common/utils/abDetailSample'
import { checkWorkStatus } from '@/common/utils/workStatusCheck'
import { initWorkCardTapSource } from '@common/utils/workCardTapTransition'
import { carousel } from '@pc/components/Carousel'
import { initKeep, keep } from '@pc/components/Keep'
import { initWorkDetailCarousel } from '@pc/components/WorkDetail/Carousel'
import { workDetailLoadImpressionLogs, workDetailViewImpressionLogs } from '@pc/components/WorkDetail/EventTrack'
import { expandAllToggle } from '@pc/components/WorkDetail/ExpandAllToggle'
import { expandToggle } from '@pc/components/WorkDetail/ExpandToggle'
import { map } from '@pc/components/WorkDetail/Map'
import { recommends } from '@pc/components/WorkDetail/Recommends'

document.addEventListener('DOMContentLoaded', () => {
  // A/Bテストサンプル（Fastly VCL方式の動作確認用）
  initAbDetailSampleTracking()

  // カードタップ時アニメーション
  initWorkCardTapSource()

  // 掲載状態チェック（Fastlyキャッシュ延長のセーフティネット）
  checkWorkStatus()

  // 1st view のカルーセル (keen-slider)
  initWorkDetailCarousel()

  // 募集職種の仕事内容の開閉
  expandToggle()

  // 募集職種の仕事内容の開閉で全部隠す
  expandAllToggle()

  // 募集職種の地図
  map()

  // 非掲載案件に直接ランディングした場合に表示されるレコメンド
  recommends()

  // GA4のインプレッションログ(loadタイプ)
  workDetailLoadImpressionLogs()

  // GA4のインプレッションログ(viewタイプ)
  workDetailViewImpressionLogs()

  // レコメンドのカルーセル
  const wrapper = document.getElementsByClassName('js-recommend-carousel-wrapper')
  if (wrapper.length > 0) {
    window.addEventListener('load', () => {
      carousel({
        wrapperSelector: '.js-recommend-carousel-wrapper',
        itemsSelector: '.js-recommend-carousel-items',
        itemSelector: '.js-recommend-carousel-item',
        leftCursorSelector: '.js-recommend-left-cursor',
        rightCursorSelector: '.js-recommend-right-cursor',
        visibleItem: 3,
        gap: 30
      })
    })
  }

  // キープ
  keep()

  // 求人ID一覧のキープ状態反映
  initKeep()
})
